import { Injectable } from "@angular/core";
import { Apollo, gql } from "apollo-angular";
import { UtilCommon } from "../UtilCommon";
import { AppState } from "../AppState";
import { AppStateConstant } from "../../constants/AppState.constant";
import { APP_CONFIG } from "app.config";
import { map } from "rxjs";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class GraphQLService {
  constructor(
    private apollo: Apollo,
    private appState: AppState,
    private router: Router
  ) { }

  getData(queryGraph: string) {
    const headers = this.getHeaderHasura();
    try {
      this.apollo
        .watchQuery({
          query: gql`
            ${queryGraph}
          `,
          context: {
            headers: headers,
          },
        })
        .valueChanges.subscribe((result: any) => { });
    } catch (error) {
      console.log(error);
    }
  }

  async getDataPromise(queryGraph: string): Promise<any> {
    try {
      const headers = await this.getHeaderHasura();
      return new Promise((resolve, reject) => {
        this.apollo
          .watchQuery({
            query: gql`
              ${queryGraph}
            `,
            context: {
              headers: headers,
            },
          })
          .valueChanges.subscribe((result: any) => {
            resolve(result.data);
          });
      });
    } catch (error) {
      console.log(error);
    }
  }

  async mutatePromise(queryGraph: string): Promise<any> {
    try {
      const headers = await this.getHeaderHasura();
      return new Promise((resolve, reject) => {
        this.apollo
          .mutate({
            mutation: gql`
              ${queryGraph}
            `,
            context: {
              headers: headers,
            },
          })
          .subscribe(
            (result: any) => {
              resolve(result.data);
            },
            (error) => {
              reject(error);
            }
          );
      });
    } catch (error) {
      console.log(error);
    }
  }

  mutateObs$(queryGraph: string) {
    const headers = this.getHeaderHasura();
    return this.apollo
      .mutate({
        mutation: gql`
            ${queryGraph}
          `,
        context: {
          headers: headers,
        },
      }).pipe(
        map((result: any) => result?.data),
      )
  }

  mutateObsWithVariable(
    queryGraph: string,
    variables: any
  ) {
    const headers = this.getHeaderHasura();
    return this.apollo
      .mutate({
        mutation: gql`
          ${queryGraph}
        `,
        context: {
          headers: headers,
        },
        variables: variables,
      })
      .pipe(
        map((result: any) => result?.data),
      )
  }

  async mutatePromiseWithVariable(
    query: string,
    variables: any
  ): Promise<any> {
    try {
      const headers = await this.getHeaderHasura();
      return new Promise((resolve, reject) => {
        this.apollo
          .mutate({
            mutation: gql`
              ${query}
            `,
            context: {
              headers: headers,
            },
            variables: variables,
          })
          .subscribe(
            (result: any) => {
              resolve(result.data);
            },
            (error) => {
              console.log("error")
              reject(error);
            }
          );
      });
    } catch (error) {
      console.log(error);
    }
  }

  mutatePromiseWithVariableObs$(
    queryGraph: string,
    variables: any
  ) {
    const headers = this.getHeaderHasura();
    return this.apollo
      .mutate({
        mutation: gql`
          ${queryGraph}
        `,
        context: {
          headers: headers,
        },
        variables: variables,
      }).pipe(
        map((result: any) => result?.data),
      )
  }

  getDefaultQuery() {
    const userInfo = this.appState.getAppState();
    return `
        makerId: "${this.appState?.getAppStateUsername()}",
        makerDate: "${UtilCommon?.genDateNow()}",
        updateId: "${this.appState.getAppStateUsername()}",
        updateDate: "${UtilCommon.genDateNow()}",
        tenantCode: "${userInfo?.moreInfo?.tenantCode}"
    `;
  }

  getDefaultUpdateQuery() {
    return `
        updateId: "${this.appState.getAppStateUsername()}",
        updateDate: "${UtilCommon.genDateNow()}"
    `;
  }

  getDefaultMutationObject(isInsert: boolean = true): any {
    const userInfo = this.appState.getAppState();
    if (isInsert) {
      return {
        makerId: this.appState?.getAppStateUsername(),
        makerDate: UtilCommon?.genDateNow(),
        updateId: this.appState.getAppStateUsername(),
        updateDate: UtilCommon.genDateNow(),
        tenantCode: userInfo?.moreInfo?.tenantCode
      };
    }
    return {
      updateId: this.appState.getAppStateUsername(),
      updateDate: UtilCommon.genDateNow()
    }
  }

  // Base64URL decode helper
  private base64UrlDecode(input: string): string {
    input = input.replace(/-/g, '+').replace(/_/g, '/');
    const pad = input.length % 4;
    if (pad) input += '='.repeat(4 - pad);
    return decodeURIComponent(
      atob(input)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
  }

  // Decode JWT payload
  private decodeJwtPayload<T = any>(token: string): T | null {
    try {
      const parts = token.split('.');
      if (parts.length !== 3) return null;
      const json = this.base64UrlDecode(parts[1]);
      return JSON.parse(json);
    } catch {
      return null;
    }
  }

  // Check exp (seconds since epoch). Optional skew buffer.
  private isJwtExpired(token: string, skewSeconds: number = 30): boolean {
    const payload = this.decodeJwtPayload<{ exp?: number }>(token);
    if (!payload?.exp) return false; // treat as non-expiring if no exp
    const nowSec = Math.floor(Date.now() / 1000);
    return payload.exp <= (nowSec + skewSeconds);
  }

  async getHeaderHasura(): Promise<any> {
    // xu ly get token o BE o day neu chua co, neu co get local
    let hasuraToken = localStorage.getItem(AppStateConstant.HasuraToken);
    let serverToken = localStorage.getItem(AppStateConstant.ServerToken);
    let action = localStorage.getItem(AppStateConstant.GraphqlAction) || "";
    localStorage.setItem(AppStateConstant.GraphqlAction, "");

    if (!hasuraToken || !serverToken) {
      throw new Error("MISSING_TOKENS");
    }

    // Validate Hasura token expiry (parse like jwt.io and check 'exp')
    if (this.isJwtExpired(hasuraToken, 30)) {
      console.warn("Hasura token expired");
      // clean up and redirect (optional)
      localStorage.removeItem(AppStateConstant.HasuraToken);
      localStorage.removeItem(AppStateConstant.ServerToken);
      try { this.router.navigate(['/sign-in']); } catch { /* ignore */ }
      throw new Error("HASURA_TOKEN_EXPIRED");
    }

    if (action) {
      return {
        Authorization: APP_CONFIG.KEY_JWT + " " + serverToken,
        "X-Hasura-Token": hasuraToken,
        "X-Hasura-Action": action
      };
    } else {
      return {
        Authorization: APP_CONFIG.KEY_JWT + " " + serverToken,
        "X-Hasura-Token": hasuraToken
      };
    }
  }
}
